/**
 * useOrder — carrega ordem com linhas + polling conforme estado
 * Polling:
 *   - DELIVERED (enviada SAP): 30s (aguarda processamento)
 *   - WAITING_HOSPITALAR_RESOLUTION: 60s (aguarda Hospital)
 */
import { useState, useEffect, useCallback } from 'react';
import api from '../services/api.js';

export function useOrder(orderId) {
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    if (!orderId) return;
    try {
      const r = await api.get(`/orders/${orderId}`);
      setOrder(r.data);
      setError(null);
    } catch (e) {
      setError(e.response?.data?.message || e.message);
    } finally {
      setLoading(false);
    }
  }, [orderId]);

  useEffect(() => {
    setLoading(true);
    refresh();
  }, [refresh]);

  // Polling DELIVERED
  useEffect(() => {
    if (order?.status_id === 3) {
      const t = setInterval(refresh, 30_000);
      return () => clearInterval(t);
    }
  }, [order?.status_id, refresh]);

  // Polling WAITING_HOSPITALAR_RESOLUTION
  useEffect(() => {
    if (order?.status_id === 8) {
      const t = setInterval(refresh, 60_000);
      return () => clearInterval(t);
    }
  }, [order?.status_id, refresh]);

  return { order, setOrder, loading, error, refresh };
}

export default useOrder;
